import { observer } from "mobx-react-lite";
import React from "react";
import { CustomPasswordInput, CustomFormControl, CustomInput } from "@lubbezposrednio-frontend/commons";
import { bindProperty, AuthorizationModel } from "@lubbezposrednio-frontend/core";
import { FiMail, FiLock } from "react-icons/fi";

interface LoginFormProps {
  authorization: AuthorizationModel;
}

export const LoginForm: React.FC<LoginFormProps> = observer(({ authorization }) => {
  const inputIds = {
    email: "email",
    password: "password",
    confirmPassword: "confirm-password"
  };

  return (
    <>
      <CustomFormControl
        id={inputIds.email}
        isInvalid={authorization.getIsTouched(inputIds.email) && !authorization.isEmailCorrect}
        errorMessage="Podany adres e-mail jest niepoprawny."
        w="100%"
        labelTitle="Email"
      >
        <CustomInput
          autoComplete="email"
          leftIcon={FiMail}
          placeholder="twoj@email.pl"
          {...bindProperty(authorization, "email")}
          onFocus={() => {
            authorization.setIsTouched(inputIds.email);
          }}
        />
      </CustomFormControl>
      <CustomFormControl
        id={inputIds.password}
        onFocus={() => {
          authorization.setIsTouched(inputIds.password);
        }}
        w="100%"
        labelTitle="Hasło"
      >
        <CustomPasswordInput leftIcon={FiLock} placeholder="Twoje hasło" {...bindProperty(authorization, "password")} />
      </CustomFormControl>
    </>
  );
});
